import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'

const fetchInfo = async () => {
  return await apiHelperService.get(`/api/individual/info`)
}
const initInfo = async () => {
  const formStore = useFormStore()
  const res = await fetchInfo()

  const {
    emailAddress,
    familyBookNo,
    englishFullName,
    arabicFullName,
    identityNumber,
    unifiedNumber
  } = res

  formStore.form.setFieldValue('individualInfo.unifiedNumber', unifiedNumber)
  formStore.form.setFieldValue('individualInfo.englishFullName', englishFullName)
  formStore.form.setFieldValue('individualInfo.arabicFullName', arabicFullName)
  formStore.form.setFieldValue('individualInfo.identityNumber', identityNumber)
  formStore.form.setFieldValue('individualInfo.familyBookNo', familyBookNo)
  formStore.form.setFieldValue('individualInfo.emailAddress', emailAddress)
}

export default async function () {
  const authStore = useAuthStore()
  const formStore = useFormStore()

  const { applicationId } = authStore.user
  // no need to pre-fill for guests
  if (applicationId == 12) return

  try {
    formStore.extraMap = {
      localAddressUserActionEnum: null,
      mobileNumbers: [],
      showSubmitButton: false
    }

    await initInfo()
  } catch (error) {
    console.error('use714Preload', error)
  }
}
